import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Exam} from "../../../shared/models/exam";
import {CertificationMockTest} from "../../../shared/models/certificationMockTest";


@Component({
    selector: "app-mock-test-confirmation-modal",
    templateUrl: "./mock-test-confirmation-modal.component.html",
    styleUrls: ["./mock-test-confirmation-modal.component.scss"]
})
export class MockTestConfirmationModalComponent {

    @Input() exam: Exam;
    @Input() mockTest: CertificationMockTest;

    constructor (public activeModal: NgbActiveModal) {}

    confirm () {
        this.activeModal.close();
    }

}
